export const LOGIN_SUCCESS = "login_success";
export const LOGOUT = "LOGOUT";
export const LOADER = "loader";
export const SET_SELECTED_ROLE = "set_selected_role";
export const SET_SELECTED_FORM_ID = "set_selected_form_id";
export const GET_DEPARTMENT_FORM_SUCCESS = "get_department_form_success";
export const IS_ANSWERED = "is_answers";
export const SET_MAIN_FLOW_ID = "set_main_flow_id";
export const SET_VIEW_ANNOUNCEMENT = "set_view_announement";
export const SET_SELECTED_FLOW_ID = "set_selected_flow_id";
export const SET_SUB_TICKET_ID = "set_sub_ticket_id";
export const USERMODALS = "USERMODALS";
export const SET_FORM_BUILDER_VALUES = "SET_FORM_BUILDER_VALUES";
export const GROUPMODALS = "GROUPMODALS";
export const SETGROUPLIST = "SETGROUPLIST";
export const IS_EDIT = "is_edit";
export const MEMBERMODAL = "MEMBERMODAL";

export const SET_FORM_BUILDER_MODE = "SET_FORM_BUILDER_MODE";
export const SET_CREATE_FORM_GROUP_LIST = "SET_CREATE_FORM_GROUP_LIST";
export const SET_CONFIGURATION_LIST = "SET_CONFIGURATION_LIST";
export const SET_IFRAME = "SET_IFRAME";

export const moneyLionCall = "answer_question";
export const fedexCall = "answer_question";
export const etsyCall = "answer_question";
export const pawsibilityCall = "pwasibility";
export const mentalCall = "mha";
export const uberCall = "answer_question";
export const vivintCall = "answer_question";
export const turoCall = "answer_question";
export const yohanaCall = "yohana";

export const MANAGE_CHATBOT = "MANAGE_CHATBOT";

export const MANAGE_USERS = "MANAGE_USERS";
export const NOTIFICATION_MODAL = "NOTIFICATION_MODAL";

export const SELECTED_REPOSITORY = "SELECTED_REPOSITORY";
export const SELECTED_REPOSITORY_VERSION = "SELECTED_REPOSITORY_VERSION";
export const IS_SELECTED_REPOSITORY = "IS_SELECTED_REPOSITORY";
export const IS_ADD_ARTICLE = "IS_ADD_ARTICLE";
export const IS_MAXIMIZE_ADD_ARTICLE = "IS_MAXIMIZE_ADD_ARTICLE";
export const GET_CATEGORY_LIST = "GET_CATEGORY_LIST";
export const STORE_TASKPDF_CHAT_HISTORY = "STORE_TASKPDF_CHAT_HISTORY";
export const TASKPDF_CHECK_API = 'TASKPDF_CHECK_API';
export const TASKPDF_HANDLE_STRING = "TASKPDF_HANDLE_STRING";

export const CHATBOTIFY_BASIC_GENERAL_DATA = "CHATBOTIFY_BASIC_GENERAL_DATA";
export const PREV_CHATBOTIFY_DATA = "PREV_CHATBOTIFY_DATA";

// Global Data Actions
export const GLOBAL_SELECTED_PRODUCT_DATA = "GLOBAL_SELECTED_PRODUCT_DATA";
export const GLOBAL_CHATBOT_ID_DATA = "GLOBAL_CHATBOT_ID_DATA";
export const GLOBAL_AUTHORAI_ID = "GLOBAL_AUTHORAI_ID";
export const GLOBAL_ASK_YOUR_DATA_ID = "GLOBAL_ASK_YOUR_DATA_ID";
export const GLOBAL_DATE_TYPE_DATA = "GLOBAL_DATE_TYPE_DATA";
export const GLOBAL_START_DATE = "GLOBAL_START_DATE";
export const GLOBAL_END_DATE = "GLOBAL_END_DATE";
export const GLOBAL_ROUTES_UPDATE = "GLOBAL_ROUTES_UPDATE";
export const DASHBOARD_TAB_UPDATE = "DASHBOARD_TAB_UPDATE";
export const PRODUCT_TAB_UPDATE = "PRODUCT_TAB_UPDATE";
export const RESET_APP_STORAGE = 'RESET_APP_STORAGE';
export const KBUTILITY_CHATBOT = 'KBUTILITY_CHATBOT';
export const DESIGNATION_UPDATE = 'DESIGNATION_UPDATE';
export const USERS_UPDTAE = 'USERS_UPDTAE';
export const REPORT_TYPE_UPDATE = 'REPORT_TYPE_UPDATE';
export const REPORT_TYPE = 'REPORT_TYPE';
export const TASKPDF_CHAT_UPDATE = 'TASKPDF_CHAT_UPDATE';
export const SITE_UPDATE = "SITE_UPDATE";
export const TEAM_TYPE_UPDATE = 'TEAM_TYPE_UPDATE';
export const DOCKER_STATUS_CHECK = 'DOCKER_STATUS_CHECK';
export const SET_NO_SERVICE_DETAILS = 'SET_NO_SERVICE_DETAILS';
export const DOCKER_STATUS_CHECK_TASKPDF = "DOCKER_STATUS_CHECK_TASKPDF";
export const DOCKER_STATUS_CHECK_TASKSCRIBE = "DOCKER_STATUS_CHECK_TASKSCRIBE"
// Logs Review Data Actions
export const LOGS_REVIEW_CHATBOT_DETAILS = "LOGS_REVIEW_CHATBOT_DETAILS";
export const LOGS_REVIEW_AUTHERAI_SELECT = "LOGS_REVIEW_AUTHERAI_SELECT";
export const LOGS_REVIEW_ASK_YOUR_DATA_SELECT = "LOGS_REVIEW_ASK_YOUR_DATA_SELECT";
export const LOGS_REVIEW_SELECTED_PRODUCT = "LOGS_REVIEW_SELECTED_PRODUCT";
export const SEARCH_FILTER = "SEARCH_FILTER";
export const LOGS_REVIEW_PAGINATION_TAKE = "LOGS_REVIEW_PAGINATION_TAKE";
export const LOGS_REVIEW_PAGINATION_PAGE = "LOGS_REVIEW_PAGINATION_PAGE";
export const TOTAL_PAGE_COUNT = "TOTAL_PAGE_COUNT";
export const LOGS_REVIEW_TOTAL_QUERY_COUNT = "LOGS_REVIEW_TOTAL_QUERY_COUNT";
export const LOGS_REVIEW_TABLE_DATA = "LOGS_REVIEW_TABLE_DATA";
export const LOGS_REVIEW_CHART_DATA = "LOGS_REVIEW_CHART_DATA";
export const LOGS_REVIEW_TABLE_LOADING = "LOGS_REVIEW_TABLE_LOADING";
export const LOGS_REVIEW_QUERY_ID = "LOGS_REVIEW_QUERY_ID";
export const RESPONSE_CONVERSATION_STEP = "RESPONSE_CONVERSATION_STEP";
export const SELECTED_PLATFORM = "SELECTED_PLATFORM";


// Product Feedback Data Actions

export const PRODUCT_FEEDBACK_CHATBOT_DETAILS = "PRODUCT_FEEDBACK_CHATBOT_DETAILS";
export const PRODUCT_FEEDBACK_SELECTED_PRODUCT = "PRODUCT_FEEDBACK_SELECTED_PRODUCT";
export const AUTHOR_AI_PLATFORM = "AUTHOR_AI_PLATFORM";
//SmartFlo Actions
export const LOGIN_SMARTFLO_APP = "LOGIN_SMARTFLO_APP"; 
export const EXTERNAL_LOGIN_SUCCESS = "external_login_success";

//PROMPT AI 
export const SELECTED_PROMPT_AI_INSTANCE = "SELECTED_PROMPT_AI_INSTANCE";
export const PROMPT_AI_SELECTED_INSTANCE = "PROMPT_AI_SELECTED_INSTANCE";
